module.exports = {"en":{"rememberAccount":"Remember this account","insecure":"(Insecure)","cancel":"Cancel"},"de":{"rememberAccount":"Diesen Account merken","insecure":"(Unsicher)","cancel":"Abbrechen"},"fr":{"rememberAccount":"Mémoriser ce compte","insecure":"(Non sécurisé)","cancel":"Annuler"},"ru":{"rememberAccount":"Запомнить эти данные","insecure":"(небезопасно)","cancel":"Отменить"},"ja":{"rememberAccount":"Remember this account","insecure":"(Insecure)"},"zh":{"rememberAccount":"记住此账号","insecure":"（不安全）","cancel":"取消"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginWindow/login-window.json
// module id = 1190
// module chunks = 0